import { combineReducers } from 'redux';
import internalLinks from '../screens/InternalLinks/reducers';
import linksSetting from '../screens/LinksSetting/reducers';
import index from '../screens/Index/reducers';
import companyAdmin from '../screens/CompanyAdmin/reducers';
import companyNews from '../screens/CompanyNews/reducers';
import companyRules from '../screens/CompanyRules/reducers';
import departmentNews from '../screens/DepartmentNews/reducers';
import stickynotes from '../screens/StickyNotes/reducers';
import assignmentTask from '../screens/AssignmentTask/reducers';
import orders from '../screens/Orders/reducers';
import message from './messageReducer';
import peoplesearch from '../screens/PeopleSearch/reducers/';
import accountSetting from '../screens/AccountSetting/reducers';
import preferenceSettings from '../screens/PreferenceSettings/reducers';

export default combineReducers({
  internalLinks,
  linksSetting,
  index,
  companyAdmin,
  companyNews,
  companyRules,
  departmentNews,
  stickynotes,
  assignmentTask,
  orders,
  message,
  peoplesearch,
  accountSetting,
  preferenceSettings,
});



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/reducers/index.js
 **/